import { FleekError } from './FleekError';

export class UserAlreadyExistsError extends FleekError<Record<string, never>> {
  public name = 'UserAlreadyExistsError';

  toString = () => 'The username is already in use, please select another one';
}
